import { Component, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { State } from 'src/app/dashboards/state';
import { callbackDisplayService } from 'src/app/services/services/callback-display.service';
import { ErrorMessage, InfoMessage } from 'src/app/common/messages';
import * as mainActions from 'src/app/state/app.actions'
import { I18NextPipe } from 'angular-i18next';
import { property } from 'src/app/models';
import { MatDialog } from '@angular/material/dialog';
import { DialogDeleteComponent } from 'src/app/common/dialogs/dialog-delete/dialog-delete.component';

@Component({
    selector: 'app-callback-display-page',
    templateUrl: './callback-display-page.component.html',
    styleUrls: ['./callback-display-page.component.scss'],
    standalone: false
})
export class CallbackDisplayPageComponent implements OnInit {

  public filterString: string = '';
  public configurations: property[] = [];
  public selectedConfigId: number = null;
  public addNewConfig: boolean = false;
  public fullscreen: boolean = false;

  constructor(private i18nextPipe: I18NextPipe, private store: Store<State>, private activatedRoute: ActivatedRoute, private router: Router,
    private service: callbackDisplayService, public dialog: MatDialog) { }

  ngOnInit(): void {
    this.getConfigs();
  }

  addNew() {
    this.addNewConfig = true;
    this.selectedConfigId = null;
  }

  filterRecords($event) {
    this.filterString = $event;
  }

  getConfigs() {
    this.service.getCallbackDisplayConfigList().subscribe(data => {
      this.configurations = data;
    });
  }

  edit(id) {
    this.selectedConfigId = id;
    this.addNewConfig = false;
  }

  hideDetails() {
    this.selectedConfigId = null;
    this.addNewConfig = false;
    this.fullscreen = false;
  }

  onFullscreen($event) {
    this.fullscreen = $event;
  }

  deleteDialog(id) {
    const dialogRef = this.dialog.open(DialogDeleteComponent, {
      disableClose: true,
      data: {
        component: this.i18nextPipe.transform('callbackDisplay:Configuration')
      },
      panelClass: 'dialog-standard-pannel',
      backdropClass: "backdrop-invisible",
      width: "350px",
      height: "150px",
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.service.deleteCallbackDisplayConfig(id).subscribe(data => {
          if (data) {
            this.getConfigs();
            this.store.dispatch(
              mainActions.addMessage({
                message: new InfoMessage(
                  this.i18nextPipe.transform('callbackDisplay:Configuration has been deleted.'), "")
              }));
          } else {
            this.store.dispatch(
              mainActions.addMessage({
                message: new ErrorMessage(
                  this.i18nextPipe.transform('callbackDisplay:Unable to save configuration!'),
                  this.i18nextPipe.transform("callbackDisplay:Please try again later."))
              }));
          }
        });
      }
    });
  }

  delete(id) {
    this.service.getCallbackDisplayUsage(id).subscribe(data => {
      if (data?.length > 0) {
        this.store.dispatch(
          mainActions.addMessage({
            message: new ErrorMessage(
              this.i18nextPipe.transform('callbackDisplay:Configuration is in use and cannot be deleted.'), "callbackDisplay:Used in System Queue(s)" + ": " + data.join(', '))
          }));
      } else {
        this.deleteDialog(id);
      }
    });
  }

}
